module.exports = __webpack_public_path__ + "static/media/plan-B1a-desktop-en.40ad295c.png";